import { GET, POST, PUT, DELETE } from "../../../api";

export const findAll = async (
  currentPage,
  perPage,
  search,
  searchDateFrom,
  searchDateTo,
) => {
  return await GET(
    `/admin/wallet?page=${currentPage || 1}&per_page=${perPage || 10}&name=${
      search || ""
    }&from=${searchDateFrom || ""}&to=${searchDateTo || ""}`,
  );
};
export const findAllAccept = async (
  currentPage,
  perPage,
  search,
  searchDateFrom,
  searchDateTo,
) => {
  return await GET(
    `/admin/wallet/accept?page=${currentPage || 1}&per_page=${
      perPage || 10
    }&name=${search || ""}&from=${searchDateFrom || ""}&to=${
      searchDateTo || ""
    }`,
  );
};
export const findAllReject = async (
  currentPage,
  perPage,
  search,
  searchDateFrom,
  searchDateTo,
) => {
  return await GET(
    `/admin/wallet/reject?page=${currentPage || 1}&per_page=${
      perPage || 10
    }&name=${search || ""}&from=${searchDateFrom || ""}&to=${
      searchDateTo || ""
    }`,
  );
};

export const findAllHistory = async (
  currentPage,
  perPage,
  search,
  gameSearch,
  walletTypeSearch,
  searchDateFrom,
  searchDateTo,
  creditDebitSearch,
  user_id,
  requestStatus,
  excludeGame,
) => {
  return await GET(
    `/admin/wallet/history?page=${currentPage || 1}&per_page=${perPage || 10}&name=${search || ""}&search_game=${gameSearch || ""}&type=${creditDebitSearch || ""}&wallet_type=${walletTypeSearch || ""}&from=${searchDateFrom || ""}&to=${searchDateTo || ""}&user_id=${user_id || ""}&request_status=${requestStatus || ""}&exclude_game=${excludeGame || ""}`,
  );
};

export const Create = async (data) => {
  return await POST(`/admin/wallet`, data);
};

export const AddRemovePoints = async (id, data) => {
  return await POST(`/admin/wallet/add-remove-points/${id}`, data);
};

export const Status = async (id, data) => {
  return await POST(`/admin/wallet/${id}`, data);
};

export const findAllDeposit = async (
  currentPage,
  perPage,
  search,
  searchDateFrom,
  searchDateTo,
) => {
  return await GET(
    `/admin/wallet/all-deposit-request?page=${currentPage || 1}&per_page=${perPage || 10}&name=${
      search || ""
    }&from=${searchDateFrom || ""}&to=${searchDateTo || ""}`,
  );
};

export const findAllDepositAccept = async (
  currentPage,
  perPage,
  search,
  searchDateFrom,
  searchDateTo,
) => {
  return await GET(
    `/admin/wallet/all-deposit-accepted-request?page=${currentPage || 1}&per_page=${
      perPage || 10
    }&name=${search || ""}&from=${searchDateFrom || ""}&to=${
      searchDateTo || ""
    }`,
  );
};

export const findAllDepositReject = async (
  currentPage,
  perPage,
  search,
  searchDateFrom,
  searchDateTo,
) => {
  return await GET(
    `/admin/wallet/all-deposit-rejected-request?page=${currentPage || 1}&per_page=${
      perPage || 10
    }&name=${search || ""}&from=${searchDateFrom || ""}&to=${
      searchDateTo || ""
    }`,
  );
};

export const DepositStatus = async (id, data) => {
  return await POST(`/admin/wallet/deposit-accept-reject/${id}`, data);
};
